import { SkuType } from '@model/Sku';
import { Engine } from '@packages/3d/Engine';
import { BuilderCustomDesignType } from '@packages/builder/models/BuilderCustomDesign';
import { BuilderModelType } from '@packages/builder/models/BuilderModel';
import { Record } from 'immutable';

export enum BUILDER_WINDOW {
    BUILDER = 'builder',
}

export enum BUILDER_PAGE {
    PRODUCT_OPTIONS = 'top-options',
    GRAPHIC_OPTIONS = 'graphic-options',
    PRODUCT_INFO = 'product-info',
}

export interface BuilderBoxStateType {
    busy: boolean;
    error: any;
    route: string;
    activeWindow: BUILDER_WINDOW;
    activePage: BUILDER_PAGE;
    customDesign: BuilderCustomDesignType | null;
    product: SkuType | null;
    engine: Engine | null;
    model: BuilderModelType | null;
}

export const BuilderBoxState = Record<BuilderBoxStateType>({
    busy: false,
    error: null,
    route: 'Builder.Customize',
    activeWindow: BUILDER_WINDOW.BUILDER,
    activePage: BUILDER_PAGE.PRODUCT_OPTIONS,
    customDesign: null,
    product: null,
    engine: null,
    model: null,
});
